import React from 'react';

export const PhotoDelete: React.FunctionComponent = () => {
    return <>Avatar Delete</>;
};

export default PhotoDelete;
